<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl">
        <div class="form-group row align-items-center">
          <label for="inputs_include_value" class="col-sm-3 mb-0">
            {{ $t("include_value") }}
          </label>
          <app-input
            id="inputs_include_value"
            class="col-sm-9"
            type="text"
            v-model="inputs.include_value"
            :required="true"
          />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper";
import { INCLUDE_STORE, INCLUDE_UPDATE } from "../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      addurl: INCLUDE_STORE,
      preloader: false,
      inputs: {},
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.addurl = INCLUDE_UPDATE;
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      // let formData = new FormData();

      // // if (this.dropzone_files.length) {
      // //   this.dropzone_files.forEach((dropzone_file) =>
      // //     formData.append(`dropzone_file[]`, dropzone_file)
      // //   );
      // // }
 
      // this.inputs.path =  this.inputs.image != null ? this.inputs.image['name'] : '';
      // Object.keys(this.inputs).forEach((key) => {
      //   formData.append(key, this.inputs[key]);
      // });
      if (this.modalTitle == "Edit") {

        this.preloader = true;
        axiosPost(this.addurl, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.result);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {

        this.save(this.inputs);
      }
      
      // this.$toastr.s(res.data.message);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.result);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs.include_value = response.data.value;
      this.inputs.id = response.data.id;
      this.preloader = false;
    },
  },
  mounted() {
  },
};
</script>
